// type 6 - 버튼이 6개인 리치메뉴 레이아웃
// type 5 - 버튼이 5개인 리치메뉴 레이아웃
// type 4 - 버튼이 4개인 리치메뉴 레이아웃
// type 3 - 버튼이 3개인 리치메뉴 레이아웃
// type 2 - 버튼이 2개인 리치메뉴 레이아웃
// type 1 - 버튼이 1개인 리치메뉴 레이아웃

// 레이아웃 리스트 - 리치메뉴 에디터 페이지에서 레이아웃 선택에 해당하는 레이아웃 선택 버튼의 이미지 파일 관리
export const layoutList = [
  {
    type: 6,
    selected: false,
    url: 'https://public-common-sdk-outaigate.s3.ap-northeast-3.amazonaws.com/image/line/richLayout06.png'
  },
  {
    type: 5,
    selected: false,
    url: 'https://public-common-sdk-outaigate.s3.ap-northeast-3.amazonaws.com/image/line/richLayout05.png'
  },
  {
    type: 4,
    selected: false,
    url: 'https://public-common-sdk-outaigate.s3.ap-northeast-3.amazonaws.com/image/line/richLayout04.png'
  },
  {
    type: 3,
    selected: false,
    url: 'https://public-common-sdk-outaigate.s3.ap-northeast-3.amazonaws.com/image/line/richLayout03.png'
  },
  {
    type: 2,
    selected: false,
    url: 'https://public-common-sdk-outaigate.s3.ap-northeast-3.amazonaws.com/image/line/richLayout02.png'
  },
  {
    type: 1,
    selected: false,
    url: 'https://public-common-sdk-outaigate.s3.ap-northeast-3.amazonaws.com/image/line/richLayout01.png'
  }
]

// value1-1 : 가로 300px, 세로 250px의 가장 작은 버튼 기준의 사진
// value2-1 : 가로 450px, 세로 250px의 버튼 기준의 사진
// value3-1 : 가로 900px, 세로 250px의 버튼 기준의 사진
// value4-1 : 가로 900px, 세로 500px의 버튼 기준의 사진

export const richMenuImageTemplate = [
  // HOME
  {
    type: 'HOME',
    value: '1-1',
    selected: false,
    url: 'https://dtiuaeh9iraj4.cloudfront.net/frame/1-1/home/frame-01.png'
  },
  {
    type: 'HOME',
    value: '1-1',
    selected: false,
    url: 'https://dtiuaeh9iraj4.cloudfront.net/frame/1-1/home/frame-02.png'
  },
  {
    type: 'HOME',
    value: '1-1',
    selected: false,
    url: 'https://dtiuaeh9iraj4.cloudfront.net/frame/1-1/home/frame-03.png'
  },
  {
    type: 'HOME',
    value: '1-1',
    selected: false,
    url: 'https://dtiuaeh9iraj4.cloudfront.net/frame/1-1/home/frame-04.png'
  },
  {
    type: 'HOME',
    value: '1-1',
    selected: false,
    url: 'https://dtiuaeh9iraj4.cloudfront.net/frame/1-1/home/frame-05.png'
  },
  {
    type: 'HOME',
    value: '1-1',
    selected: false,
    url: 'https://dtiuaeh9iraj4.cloudfront.net/frame/1-1/home/frame-06.png'
  },
  {
    type: 'HOME',
    value: '1-1',
    selected: false,
    url: 'https://dtiuaeh9iraj4.cloudfront.net/frame/1-1/home/frame-07.png'
  },
  {
    type: 'HOME',
    value: '1-1',
    selected: false,
    url: 'https://dtiuaeh9iraj4.cloudfront.net/frame/1-1/home/frame-08.png'
  },
  {
    type: 'HOME',
    value: '1-1',
    selected: false,
    url: 'https://dtiuaeh9iraj4.cloudfront.net/frame/1-1/home/frame-09.png'
  },
  {
    type: 'HOME',
    value: '2-1',
    selected: false,
    url: 'https://dtiuaeh9iraj4.cloudfront.net/frame/2-1/home/frame-01.png'
  },
  {
    type: 'HOME',
    value: '2-1',
    selected: false,
    url: 'https://dtiuaeh9iraj4.cloudfront.net/frame/2-1/home/frame-02.png'
  },
  {
    type: 'HOME',
    value: '2-1',
    selected: false,
    url: 'https://dtiuaeh9iraj4.cloudfront.net/frame/2-1/home/frame-03.png'
  },
  {
    type: 'HOME',
    value: '2-1',
    selected: false,
    url: 'https://dtiuaeh9iraj4.cloudfront.net/frame/2-1/home/frame-04.png'
  },
  {
    type: 'HOME',
    value: '2-1',
    selected: false,
    url: 'https://dtiuaeh9iraj4.cloudfront.net/frame/2-1/home/frame-05.png'
  },
  {
    type: 'HOME',
    value: '2-1',
    selected: false,
    url: 'https://dtiuaeh9iraj4.cloudfront.net/frame/2-1/home/frame-06.png'
  },
  {
    type: 'HOME',
    value: '2-1',
    selected: false,
    url: 'https://dtiuaeh9iraj4.cloudfront.net/frame/2-1/home/frame-07.png'
  },
  {
    type: 'HOME',
    value: '2-1',
    selected: false,
    url: 'https://dtiuaeh9iraj4.cloudfront.net/frame/2-1/home/frame-08.png'
  },
  {
    type: 'HOME',
    value: '2-1',
    selected: false,
    url: 'https://dtiuaeh9iraj4.cloudfront.net/frame/2-1/home/frame-09.png'
  },
  {
    type: 'HOME',
    value: '3-1',
    selected: false,
    url: 'https://dtiuaeh9iraj4.cloudfront.net/frame/3-1/home/frame-01.png'
  },
  {
    type: 'HOME',
    value: '3-1',
    selected: false,
    url: 'https://dtiuaeh9iraj4.cloudfront.net/frame/3-1/home/frame-02.png'
  },
  {
    type: 'HOME',
    value: '3-1',
    selected: false,
    url: 'https://dtiuaeh9iraj4.cloudfront.net/frame/3-1/home/frame-03.png'
  },
  {
    type: 'HOME',
    value: '3-1',
    selected: false,
    url: 'https://dtiuaeh9iraj4.cloudfront.net/frame/3-1/home/frame-04.png'
  },
  {
    type: 'HOME',
    value: '3-1',
    selected: false,
    url: 'https://dtiuaeh9iraj4.cloudfront.net/frame/3-1/home/frame-05.png'
  },
  {
    type: 'HOME',
    value: '3-1',
    selected: false,
    url: 'https://dtiuaeh9iraj4.cloudfront.net/frame/3-1/home/frame-06.png'
  },
  {
    type: 'HOME',
    value: '3-1',
    selected: false,
    url: 'https://dtiuaeh9iraj4.cloudfront.net/frame/3-1/home/frame-07.png'
  },
  {
    type: 'HOME',
    value: '3-1',
    selected: false,
    url: 'https://dtiuaeh9iraj4.cloudfront.net/frame/3-1/home/frame-08.png'
  },
  {
    type: 'HOME',
    value: '3-1',
    selected: false,
    url: 'https://dtiuaeh9iraj4.cloudfront.net/frame/3-1/home/frame-09.png'
  },
  {
    type: 'HOME',
    value: '4-1',
    selected: false,
    url: 'https://dtiuaeh9iraj4.cloudfront.net/frame/4-1/home/frame-01.png'
  },
  {
    type: 'HOME',
    value: '4-1',
    selected: false,
    url: 'https://dtiuaeh9iraj4.cloudfront.net/frame/4-1/home/frame-02.png'
  },
  {
    type: 'HOME',
    value: '4-1',
    selected: false,
    url: 'https://dtiuaeh9iraj4.cloudfront.net/frame/4-1/home/frame-03.png'
  },
  {
    type: 'HOME',
    value: '4-1',
    selected: false,
    url: 'https://dtiuaeh9iraj4.cloudfront.net/frame/4-1/home/frame-04.png'
  },
  {
    type: 'HOME',
    value: '4-1',
    selected: false,
    url: 'https://dtiuaeh9iraj4.cloudfront.net/frame/4-1/home/frame-05.png'
  },
  {
    type: 'HOME',
    value: '4-1',
    selected: false,
    url: 'https://dtiuaeh9iraj4.cloudfront.net/frame/4-1/home/frame-06.png'
  },
  {
    type: 'HOME',
    value: '4-1',
    selected: false,
    url: 'https://dtiuaeh9iraj4.cloudfront.net/frame/4-1/home/frame-07.png'
  },
  {
    type: 'HOME',
    value: '4-1',
    selected: false,
    url: 'https://dtiuaeh9iraj4.cloudfront.net/frame/4-1/home/frame-08.png'
  },
  {
    type: 'HOME',
    value: '4-1',
    selected: false,
    url: 'https://dtiuaeh9iraj4.cloudfront.net/frame/4-1/home/frame-09.png'
  },
  {
    type: 'CHATBOT',
    value: '1-1',
    selected: false,
    url: 'https://dtiuaeh9iraj4.cloudfront.net/frame/1-1/chatBot/frame-01.png'
  },
  {
    type: 'CHATBOT',
    value: '1-1',
    selected: false,
    url: 'https://dtiuaeh9iraj4.cloudfront.net/frame/1-1/chatBot/frame-02.png'
  },
  {
    type: 'CHATBOT',
    value: '1-1',
    selected: false,
    url: 'https://dtiuaeh9iraj4.cloudfront.net/frame/1-1/chatBot/frame-03.png'
  },
  {
    type: 'CHATBOT',
    value: '1-1',
    selected: false,
    url: 'https://dtiuaeh9iraj4.cloudfront.net/frame/1-1/chatBot/frame-04.png'
  },
  {
    type: 'CHATBOT',
    value: '1-1',
    selected: false,
    url: 'https://dtiuaeh9iraj4.cloudfront.net/frame/1-1/chatBot/frame-05.png'
  },
  {
    type: 'CHATBOT',
    value: '1-1',
    selected: false,
    url: 'https://dtiuaeh9iraj4.cloudfront.net/frame/1-1/chatBot/frame-06.png'
  },
  {
    type: 'CHATBOT',
    value: '1-1',
    selected: false,
    url: 'https://dtiuaeh9iraj4.cloudfront.net/frame/1-1/chatBot/frame-07.png'
  },
  {
    type: 'CHATBOT',
    value: '1-1',
    selected: false,
    url: 'https://dtiuaeh9iraj4.cloudfront.net/frame/1-1/chatBot/frame-08.png'
  },
  {
    type: 'CHATBOT',
    value: '1-1',
    selected: false,
    url: 'https://dtiuaeh9iraj4.cloudfront.net/frame/1-1/chatBot/frame-09.png'
  },
  {
    type: 'CHATBOT',
    value: '2-1',
    selected: false,
    url: 'https://dtiuaeh9iraj4.cloudfront.net/frame/2-1/chatBot/frame-01.png'
  },
  {
    type: 'CHATBOT',
    value: '2-1',
    selected: false,
    url: 'https://dtiuaeh9iraj4.cloudfront.net/frame/2-1/chatBot/frame-02.png'
  },
  {
    type: 'CHATBOT',
    value: '2-1',
    selected: false,
    url: 'https://dtiuaeh9iraj4.cloudfront.net/frame/2-1/chatBot/frame-03.png'
  },
  {
    type: 'CHATBOT',
    value: '2-1',
    selected: false,
    url: 'https://dtiuaeh9iraj4.cloudfront.net/frame/2-1/chatBot/frame-04.png'
  },
  {
    type: 'CHATBOT',
    value: '2-1',
    selected: false,
    url: 'https://dtiuaeh9iraj4.cloudfront.net/frame/2-1/chatBot/frame-05.png'
  },
  {
    type: 'CHATBOT',
    value: '2-1',
    selected: false,
    url: 'https://dtiuaeh9iraj4.cloudfront.net/frame/2-1/chatBot/frame-06.png'
  },
  {
    type: 'CHATBOT',
    value: '2-1',
    selected: false,
    url: 'https://dtiuaeh9iraj4.cloudfront.net/frame/2-1/chatBot/frame-07.png'
  },
  {
    type: 'CHATBOT',
    value: '2-1',
    selected: false,
    url: 'https://dtiuaeh9iraj4.cloudfront.net/frame/2-1/chatBot/frame-08.png'
  },
  {
    type: 'CHATBOT',
    value: '2-1',
    selected: false,
    url: 'https://dtiuaeh9iraj4.cloudfront.net/frame/2-1/chatBot/frame-09.png'
  },
  {
    type: 'CHATBOT',
    value: '3-1',
    selected: false,
    url: 'https://dtiuaeh9iraj4.cloudfront.net/frame/3-1/chatBot/frame-01.png'
  },
  {
    type: 'CHATBOT',
    value: '3-1',
    selected: false,
    url: 'https://dtiuaeh9iraj4.cloudfront.net/frame/3-1/chatBot/frame-02.png'
  },
  {
    type: 'CHATBOT',
    value: '3-1',
    selected: false,
    url: 'https://dtiuaeh9iraj4.cloudfront.net/frame/3-1/chatBot/frame-03.png'
  },
  {
    type: 'CHATBOT',
    value: '3-1',
    selected: false,
    url: 'https://dtiuaeh9iraj4.cloudfront.net/frame/3-1/chatBot/frame-04.png'
  },
  {
    type: 'CHATBOT',
    value: '3-1',
    selected: false,
    url: 'https://dtiuaeh9iraj4.cloudfront.net/frame/3-1/chatBot/frame-05.png'
  },
  {
    type: 'CHATBOT',
    value: '3-1',
    selected: false,
    url: 'https://dtiuaeh9iraj4.cloudfront.net/frame/3-1/chatBot/frame-06.png'
  },
  {
    type: 'CHATBOT',
    value: '3-1',
    selected: false,
    url: 'https://dtiuaeh9iraj4.cloudfront.net/frame/3-1/chatBot/frame-07.png'
  },
  {
    type: 'CHATBOT',
    value: '3-1',
    selected: false,
    url: 'https://dtiuaeh9iraj4.cloudfront.net/frame/3-1/chatBot/frame-08.png'
  },
  {
    type: 'CHATBOT',
    value: '3-1',
    selected: false,
    url: 'https://dtiuaeh9iraj4.cloudfront.net/frame/3-1/chatBot/frame-09.png'
  },
  {
    type: 'CHATBOT',
    value: '4-1',
    selected: false,
    url: 'https://dtiuaeh9iraj4.cloudfront.net/frame/4-1/chatBot/frame-01.png'
  },
  {
    type: 'CHATBOT',
    value: '4-1',
    selected: false,
    url: 'https://dtiuaeh9iraj4.cloudfront.net/frame/4-1/chatBot/frame-02.png'
  },
  {
    type: 'CHATBOT',
    value: '4-1',
    selected: false,
    url: 'https://dtiuaeh9iraj4.cloudfront.net/frame/4-1/chatBot/frame-03.png'
  },
  {
    type: 'CHATBOT',
    value: '4-1',
    selected: false,
    url: 'https://dtiuaeh9iraj4.cloudfront.net/frame/4-1/chatBot/frame-04.png'
  },
  {
    type: 'CHATBOT',
    value: '4-1',
    selected: false,
    url: 'https://dtiuaeh9iraj4.cloudfront.net/frame/4-1/chatBot/frame-05.png'
  },
  {
    type: 'CHATBOT',
    value: '4-1',
    selected: false,
    url: 'https://dtiuaeh9iraj4.cloudfront.net/frame/4-1/chatBot/frame-06.png'
  },
  {
    type: 'CHATBOT',
    value: '4-1',
    selected: false,
    url: 'https://dtiuaeh9iraj4.cloudfront.net/frame/4-1/chatBot/frame-07.png'
  },
  {
    type: 'CHATBOT',
    value: '4-1',
    selected: false,
    url: 'https://dtiuaeh9iraj4.cloudfront.net/frame/4-1/chatBot/frame-08.png'
  },
  {
    type: 'CHATBOT',
    value: '4-1',
    selected: false,
    url: 'https://dtiuaeh9iraj4.cloudfront.net/frame/4-1/chatBot/frame-09.png'
  },
  {
    type: 'SNS',
    value: '1-1',
    selected: false,
    url: 'https://dtiuaeh9iraj4.cloudfront.net/frame/1-1/SNS/frame-01.png'
  },
  {
    type: 'SNS',
    value: '1-1',
    selected: false,
    url: 'https://dtiuaeh9iraj4.cloudfront.net/frame/1-1/SNS/frame-02.png'
  },
  {
    type: 'SNS',
    value: '1-1',
    selected: false,
    url: 'https://dtiuaeh9iraj4.cloudfront.net/frame/1-1/SNS/frame-03.png'
  },
  {
    type: 'SNS',
    value: '1-1',
    selected: false,
    url: 'https://dtiuaeh9iraj4.cloudfront.net/frame/1-1/SNS/frame-04.png'
  },
  {
    type: 'SNS',
    value: '1-1',
    selected: false,
    url: 'https://dtiuaeh9iraj4.cloudfront.net/frame/1-1/SNS/frame-05.png'
  },
  {
    type: 'SNS',
    value: '1-1',
    selected: false,
    url: 'https://dtiuaeh9iraj4.cloudfront.net/frame/1-1/SNS/frame-06.png'
  },
  {
    type: 'SNS',
    value: '2-1',
    selected: false,
    url: 'https://dtiuaeh9iraj4.cloudfront.net/frame/2-1/SNS/frame-01.png'
  },
  {
    type: 'SNS',
    value: '2-1',
    selected: false,
    url: 'https://dtiuaeh9iraj4.cloudfront.net/frame/2-1/SNS/frame-02.png'
  },
  {
    type: 'SNS',
    value: '2-1',
    selected: false,
    url: 'https://dtiuaeh9iraj4.cloudfront.net/frame/2-1/SNS/frame-03.png'
  },
  {
    type: 'SNS',
    value: '2-1',
    selected: false,
    url: 'https://dtiuaeh9iraj4.cloudfront.net/frame/2-1/SNS/frame-04.png'
  },
  {
    type: 'SNS',
    value: '2-1',
    selected: false,
    url: 'https://dtiuaeh9iraj4.cloudfront.net/frame/2-1/SNS/frame-05.png'
  },
  {
    type: 'SNS',
    value: '2-1',
    selected: false,
    url: 'https://dtiuaeh9iraj4.cloudfront.net/frame/2-1/SNS/frame-06.png'
  },
  {
    type: 'SNS',
    value: '3-1',
    selected: false,
    url: 'https://dtiuaeh9iraj4.cloudfront.net/frame/3-1/SNS/frame-01.png'
  },
  {
    type: 'SNS',
    value: '3-1',
    selected: false,
    url: 'https://dtiuaeh9iraj4.cloudfront.net/frame/3-1/SNS/frame-02.png'
  },
  {
    type: 'SNS',
    value: '3-1',
    selected: false,
    url: 'https://dtiuaeh9iraj4.cloudfront.net/frame/3-1/SNS/frame-03.png'
  },
  {
    type: 'SNS',
    value: '3-1',
    selected: false,
    url: 'https://dtiuaeh9iraj4.cloudfront.net/frame/3-1/SNS/frame-04.png'
  },
  {
    type: 'SNS',
    value: '3-1',
    selected: false,
    url: 'https://dtiuaeh9iraj4.cloudfront.net/frame/3-1/SNS/frame-05.png'
  },
  {
    type: 'SNS',
    value: '3-1',
    selected: false,
    url: 'https://dtiuaeh9iraj4.cloudfront.net/frame/3-1/SNS/frame-06.png'
  },
  {
    type: 'SNS',
    value: '4-1',
    selected: false,
    url: 'https://dtiuaeh9iraj4.cloudfront.net/frame/4-1/SNS/frame-01.png'
  },
  {
    type: 'SNS',
    value: '4-1',
    selected: false,
    url: 'https://dtiuaeh9iraj4.cloudfront.net/frame/4-1/SNS/frame-02.png'
  },
  {
    type: 'SNS',
    value: '4-1',
    selected: false,
    url: 'https://dtiuaeh9iraj4.cloudfront.net/frame/4-1/SNS/frame-03.png'
  },
  {
    type: 'SNS',
    value: '4-1',
    selected: false,
    url: 'https://dtiuaeh9iraj4.cloudfront.net/frame/4-1/SNS/frame-04.png'
  },
  {
    type: 'SNS',
    value: '4-1',
    selected: false,
    url: 'https://dtiuaeh9iraj4.cloudfront.net/frame/4-1/SNS/frame-05.png'
  },
  {
    type: 'SNS',
    value: '4-1',
    selected: false,
    url: 'https://dtiuaeh9iraj4.cloudfront.net/frame/4-1/SNS/frame-06.png'
  },
  {
    type: 'RESEARCH',
    value: '1-1',
    selected: false,
    url: 'https://dtiuaeh9iraj4.cloudfront.net/frame/1-1/research/frame-07.png'
  },
  {
    type: 'RESEARCH',
    value: '1-1',
    selected: false,
    url: 'https://dtiuaeh9iraj4.cloudfront.net/frame/1-1/research/frame-08.png'
  },
  {
    type: 'RESEARCH',
    value: '1-1',
    selected: false,
    url: 'https://dtiuaeh9iraj4.cloudfront.net/frame/1-1/research/frame-09.png'
  },
  {
    type: 'RESEARCH',
    value: '2-1',
    selected: false,
    url: 'https://dtiuaeh9iraj4.cloudfront.net/frame/2-1/research/frame-07.png'
  },
  {
    type: 'RESEARCH',
    value: '2-1',
    selected: false,
    url: 'https://dtiuaeh9iraj4.cloudfront.net/frame/2-1/research/frame-08.png'
  },
  {
    type: 'RESEARCH',
    value: '2-1',
    selected: false,
    url: 'https://dtiuaeh9iraj4.cloudfront.net/frame/2-1/research/frame-09.png'
  },
  {
    type: 'RESEARCH',
    value: '3-1',
    selected: false,
    url: 'https://dtiuaeh9iraj4.cloudfront.net/frame/3-1/research/frame-07.png'
  },
  {
    type: 'RESEARCH',
    value: '3-1',
    selected: false,
    url: 'https://dtiuaeh9iraj4.cloudfront.net/frame/3-1/research/frame-08.png'
  },
  {
    type: 'RESEARCH',
    value: '3-1',
    selected: false,
    url: 'https://dtiuaeh9iraj4.cloudfront.net/frame/3-1/research/frame-09.png'
  },
  {
    type: 'RESEARCH',
    value: '4-1',
    selected: false,
    url: 'https://dtiuaeh9iraj4.cloudfront.net/frame/4-1/research/frame-07.png'
  },
  {
    type: 'RESEARCH',
    value: '4-1',
    selected: false,
    url: 'https://dtiuaeh9iraj4.cloudfront.net/frame/4-1/research/frame-08.png'
  },
  {
    type: 'RESEARCH',
    value: '4-1',
    selected: false,
    url: 'https://dtiuaeh9iraj4.cloudfront.net/frame/4-1/research/frame-09.png'
  },
  {
    type: 'RESERVATION',
    value: '1-1',
    selected: false,
    url: 'https://dtiuaeh9iraj4.cloudfront.net/frame/1-1/reservation/frame-07.png'
  },
  {
    type: 'RESERVATION',
    value: '1-1',
    selected: false,
    url: 'https://dtiuaeh9iraj4.cloudfront.net/frame/1-1/reservation/frame-08.png'
  },
  {
    type: 'RESERVATION',
    value: '1-1',
    selected: false,
    url: 'https://dtiuaeh9iraj4.cloudfront.net/frame/1-1/reservation/frame-09.png'
  },
  {
    type: 'RESERVATION',
    value: '2-1',
    selected: false,
    url: 'https://dtiuaeh9iraj4.cloudfront.net/frame/2-1/reservation/frame-07.png'
  },
  {
    type: 'RESERVATION',
    value: '2-1',
    selected: false,
    url: 'https://dtiuaeh9iraj4.cloudfront.net/frame/2-1/reservation/frame-08.png'
  },
  {
    type: 'RESERVATION',
    value: '2-1',
    selected: false,
    url: 'https://dtiuaeh9iraj4.cloudfront.net/frame/2-1/reservation/frame-09.png'
  },
  {
    type: 'RESERVATION',
    value: '3-1',
    selected: false,
    url: 'https://dtiuaeh9iraj4.cloudfront.net/frame/3-1/reservation/frame-07.png'
  },
  {
    type: 'RESERVATION',
    value: '3-1',
    selected: false,
    url: 'https://dtiuaeh9iraj4.cloudfront.net/frame/3-1/reservation/frame-08.png'
  },
  {
    type: 'RESERVATION',
    value: '3-1',
    selected: false,
    url: 'https://dtiuaeh9iraj4.cloudfront.net/frame/3-1/reservation/frame-09.png'
  },
  {
    type: 'RESERVATION',
    value: '4-1',
    selected: false,
    url: 'https://dtiuaeh9iraj4.cloudfront.net/frame/4-1/reservation/frame-07.png'
  },
  {
    type: 'RESERVATION',
    value: '4-1',
    selected: false,
    url: 'https://dtiuaeh9iraj4.cloudfront.net/frame/4-1/reservation/frame-08.png'
  },
  {
    type: 'RESERVATION',
    value: '4-1',
    selected: false,
    url: 'https://dtiuaeh9iraj4.cloudfront.net/frame/4-1/reservation/frame-09.png'
  }
]

// 리치메뉴 사이즈 : 라인 api로 보내는 리치메뉴의 경우 하나의 사진으로 병합하여 전송하고 있음
// 픽셀로 정한 각 영역을 클릭하면 버튼처럼 동작한다.

export const richMenuSize = [
  {
    type: 6,
    size: [
      {
        value: '1-1',
        width: 300,
        height: 250,
        x: 0,
        y: 0
      },
      {
        value: '1-1',
        width: 300,
        height: 250,
        x: 301,
        y: 0
      },
      {
        value: '1-1',
        width: 300,
        height: 250,
        x: 601,
        y: 0
      },
      {
        value: '1-1',
        width: 300,
        height: 250,
        x: 0,
        y: 251
      },
      {
        value: '1-1',
        width: 300,
        height: 250,
        x: 301,
        y: 251
      },
      {
        value: '1-1',
        width: 300,
        height: 250,
        x: 601,
        y: 251
      }
    ]
  },
  {
    type: 5,
    size: [
      {
        value: '2-1',
        width: 450,
        height: 250,
        x: 0,
        y: 0
      },
      {
        value: '2-1',
        width: 450,
        height: 250,
        x: 451,
        y: 0
      },
      {
        value: '1-1',
        width: 300,
        height: 250,
        x: 0,
        y: 251
      },
      {
        value: '1-1',
        width: 300,
        height: 250,
        x: 301,
        y: 251
      },
      {
        value: '1-1',
        width: 300,
        height: 250,
        x: 601,
        y: 251
      }
    ]
  },
  {
    type: 4,
    size: [
      {
        value: '2-1',
        width: 450,
        height: 250,
        x: 0,
        y: 0
      },
      {
        value: '2-1',
        width: 450,
        height: 250,
        x: 451,
        y: 0
      },
      {
        value: '2-1',
        width: 450,
        height: 250,
        x: 0,
        y: 251
      },
      {
        value: '2-1',
        width: 450,
        height: 250,
        x: 451,
        y: 251
      }
    ]
  },
  {
    type: 3,
    size: [
      {
        value: '3-1',
        width: 900,
        height: 250,
        x: 0,
        y: 0
      },
      {
        value: '2-1',
        width: 450,
        height: 250,
        x: 0,
        y: 251
      },
      {
        value: '2-1',
        width: 450,
        height: 250,
        x: 451,
        y: 251
      }
    ]
  },
  {
    type: 2,
    size: [
      {
        value: '3-1',
        width: 900,
        height: 250,
        x: 0,
        y: 0
      },
      {
        value: '3-1',
        width: 900,
        height: 250,
        x: 0,
        y: 251
      }
    ]
  },
  {
    type: 1,
    size: [
      {
        value: '4-1',
        width: 900,
        height: 500,
        x: 0,
        y: 0
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/store/modules/marketingRich/data.js